import { hydrateRoot } from 'react-dom/client';
import './index.css';
import CountryShell from './CountryShell.jsx';
import CountryTestCentresShell from './CountryTestCentresShell.jsx';
import { countryFromPath } from './countries.js';

const country = countryFromPath(window.location.pathname);
const path = window.location.pathname.replace(/\/+$/, '');
const isTestCentres = /^\/[a-z]{2}\/test-centres$/i.test(path);

const root = document.getElementById('country-root');
if (isTestCentres) {
  const centres = window.__SC_CENTRES__ || [];
  hydrateRoot(root, <CountryTestCentresShell country={country} centres={centres} />);
} else {
  hydrateRoot(root, <CountryShell country={country} />);
}
